export { DefaultPalette } from '@fluentui/theme/lib/colors/DefaultPalette';
